import { render, staticRenderFns } from "./Son.vue?vue&type=template&id=699d25ce&scoped=true&"
import script from "./Son.vue?vue&type=script&lang=js&"
export * from "./Son.vue?vue&type=script&lang=js&"
import style0 from "./Son.vue?vue&type=style&index=0&id=699d25ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699d25ce",
  null
  
)

export default component.exports